import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GATrackingEventType,
  GaTrackingEventCategory,
  GaTrackingEventName,
  GaTrackingStringConstantEnum,
  offerTypes,
} from '../../constants';
import { Product } from '~shared/models';
import get from 'lodash.get';
import { Category } from '~app/modules/generic/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';

export class GaTrackingViewRecommendationEvent implements GATrackingEvent {
  constructor(private products: Product[], private index: number, private priceType?: PriceTypes) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ViewRecommendation;
  }

  getPayload(): GATrackingEventPayload {
    const productPromoViewTracking = {
      category: GaTrackingEventCategory.Ecommerce,
      ecommerce: {
        items: this.products
          .map((item: Product, index: number) => {
            return {
              item_name: get(item, 'name'),
              item_id: get(item, 'id'),
              price:
                this.priceType === PriceTypes.b2b
                  ? get(item, 'bestOffer.price.netPrice', 0)
                  : get(item, 'bestOffer.price.grossPrice', 0),
              item_brand: item?.attributes?.brand?.name,
              ...([...item?.categories].reverse() as any)?.reduce(
                (categories: {}, category: Category, categoryIndex: number) => {
                  if (categoryIndex === 0) {
                    categories['item_category'] = category.name;
                  } else {
                    categories[`item_category${categoryIndex + 1}`] = category.name;
                  }
                  return categories;
                },
                {}
              ),
              item_list_name: GaTrackingStringConstantEnum.Carousel,
              item_promo: item?.hasPromotion ? GaTrackingStringConstantEnum.Yes : GaTrackingStringConstantEnum.No,
              item_strikethrough: item?.bestOffer?.referencePrice?.priceType,
              item_energy_label: item?.attributes?.energyEfficiencyClass,
              item_volume_pricing: !!item?.bestOffer?.volumePrice?.length
                ? GaTrackingStringConstantEnum.Yes
                : GaTrackingStringConstantEnum.No,
              item_other_offers: GaTrackingStringConstantEnum.No,
              item_offer_type: offerTypes.cheapest,
              item_discount_rate: item?.bestOffer?.referencePrice?.discountPercentage,
              index: index,
            };
          })
          .filter(Boolean),
      },
    };

    return {
      event: GaTrackingEventName.ViewRecommendation,
      gtmCustom: productPromoViewTracking,
    };
  }
}
